import { render } from "./EmptyBox.vue?vue&type=template&id=30194888&scoped=true"
const script = {}

import "./EmptyBox.vue?vue&type=style&index=0&id=30194888&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30194888"]])

export default __exports__